module.exports.config = {
  "DSA": {
    "fullName": "Data Structures and Algorithms",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Backend": {
    "fullName": "Backend concepts",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Frontend": {
    "fullName": "Front-end fundamentals",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "DA": {
    "fullName": "Data Analytics concepts",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "QE": {
    "fullName": "Quality Engineering concepts",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "DevOps": {
    "fullName": "DevOps/SRE fundamentals",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "DockerKub": {
    "fullName": "Docker & Kubernetes",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Java": {
    "fullName": "Java",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "JavaScript": {
    "fullName": "JavaScript",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "Python": {
    "fullName": "Python",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "Golang": {
    "fullName": "Golang",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "C": {
    "fullName": "C",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "C#": {
    "fullName": "C#",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "C++": {
    "fullName": "C++",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "Scala": {
    "fullName": "Scala",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "R": {
    "fullName": "R",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "Swift": {
    "fullName": "Swift",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "Kotlin": {
    "fullName": "Kotlin",
    "isLanguageSkill": true,
    "isRoleSkill": true
  },
  "React": {
    "fullName": "React",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Angular": {
    "fullName": "Angular",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Node": {
    "fullName": "Node.js",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Spring": {
    "fullName": "Spring",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "PHP": {
    "fullName": "PHP",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "AWS": {
    "fullName": "AWS",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "GCP": {
    "fullName": "GCP",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Azure": {
    "fullName": "Azure",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Git": {
    "fullName": "Git",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Kafka": {
    "fullName": "Kafka",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "SQL": {
    "fullName": "SQL",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "MongoDB": {
    "fullName": "MongoDB",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Spark": {
    "fullName": "Spark",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "Selenium": {
    "fullName": "Selenium",
    "isLanguageSkill": false,
    "isRoleSkill": true
  },
  "AIML": {
    "fullName": "Artificial Intelligence and Machine Learning",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "DE": {
    "fullName": "Data Engineering",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "BigData": {
    "fullName": "Big Data",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "Ruby": {
    "fullName": "Ruby",
    "isLanguageSkill": true,
    "isRoleSkill": false
  },
  "TypeScript": {
    "fullName": "TypeScript",
    "isLanguageSkill": true,
    "isRoleSkill": false
  },
  "ProdM": {
    "fullName": "Product Management",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "ProjM": {
    "fullName": "Project Management",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "UX": {
    "fullName": "User Experience",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "Android": {
    "fullName": "Android",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "iOS": {
    "fullName": "iOS",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "Unix": {
    "fullName": "Unix",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "Architecture": {
    "fullName": "System Architecture",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "Networking": {
    "fullName": "Networking",
    "isLanguageSkill": false,
    "isRoleSkill": false
  },
  "Cloud": {
    "fullName": "Cloud Technology",
    "isLanguageSkill": false,
    "isRoleSkill": false
  }
}